<section class="sg-documents-container ml-3">
    <div class="row mx-0 margin-top-bottom mt-3">
        <div class="col-6">
            <h4 class="sg-page-title">Branding & QR Code Generator</h4>
        </div>
    </div>
</section>

<section class="sg-main cws-form-container complianceRegulations mb-5">
    <div class="pr-5 pl-5 pt-5 pb-3">
        <div class="row mx-0">
            <div class="mat-dialog-title border-bottom w-100 pb-2">QR Codes</div>
            <div class="col-12 px-0 mt-3">
                <p class="sg-qr-para-1">{{product_spec_Data.introParagraph}}</p>
            </div>
            <div class="mat-dialog-title border-bottom w-100 pb-2">QR Code Generator</div>
            <div class="col-12 px-0 mt-3">
                <div class="row mx-0 my-3 sg-qr-conatiner d-flex flex-wrap">
                    <div class="col-5 px-0 sg-general-qr mr-3">
                        <div class="row mx-0 flex-nowrap">
                            <div class="col-5 py-3 d-flex justify-content-center sg-qr-image">
                                <qrcode [qrdata]="staticQREnvUrl" [width]="170"
                                    style="max-width: 100%;display: block;height: auto;margin: 0 auto;max-height: 170px;margin-top: 0.25rem;"
                                    [errorCorrectionLevel]="'M'">
                
                                </qrcode>
                            </div>
                            <div class="col-7 sg-qr-right pt-3 pb-2 pl-3 pr-3 sg-qr-home-right">
                                <p class="text-capitalize title mb-0">Homepage QR Code</p>
                                <p class="sg-sub-title mb-2">(Use this on part packaging to direct users to <a href="HTTP://Shop.Solarturbines.com" target="_blank"><u>HTTP://Shop.Solarturbines.com</u></a>)</p>
                                <div class="content pt-2 mb-2">
                                    To download, click on  “Download QR” to download the images.
                                </div>
                                <div class="mt-3 py-2 sg-home-btn">
                                    <button mat-raised-button class="mat-raised-button mat-primary d-flex align-items-center"
                                        (click)="onClickGenerateDownloadLink('Shop.Solarturbines.com_Home_QR_Images')">
                                        <mat-icon>download</mat-icon>
                                        <span>Download QR</span>
                                    </button>
                                </div>
                                
                            </div>
                        </div>
                
                    </div>
                    <div class="col-6 px-0 sg-parts-qr">
                        <div class="row mx-0 flex-nowrap">
                            <div class="col-5 py-3 d-flex justify-content-center sg-qr-image">
                                <qrcode [qrdata]="envUrlPrefix" [width]="170"
                                    style="max-width: 100%;display: block;height: auto;margin: 0 auto;max-height: 170px;margin-top: 0.25rem;"
                                    [errorCorrectionLevel]="'M'">
                
                                </qrcode>
                            </div>
                            <div class="col-7 sg-qr-right pt-3 pb-2 pl-3 pr-2 sg-qr-part-right">
                                <p class="text-capitalize title mb-0">Part Page QR Code</p>
                                <p class="sg-sub-title mb-2">(Search and download Part page QR codes to direct the user to a specific part detail page.)</p>
                                <div class="content">
                                    <ol>
                                        <li *ngFor="let steps of product_spec_Data.partQRBullete">{{steps}}</li>
                                    </ol>
                                    
                                </div>
                                <div class="row mx-0 mt-0 pb-2 w-100 d-flex flex-wrap align-items-start">
                                    <div class="col-7 px-0">
                                        <mat-form-field appearance="outline" class="sg-search-qr" style="width: 95%;">
                                            <input type="text" matInput placeholder="Search part number" [(ngModel)]="searchQuery"
                                                (input)="onSearchInput($event)">
                                        </mat-form-field>
                                        <mat-error *ngIf="showMaxLimitError" style="font-size: 12px;">Max 30 char Limit.</mat-error>
                                        <mat-error *ngIf="showPartNumberError || downloadqrResponse?.fileName" style="font-size: 12px;">Entered Part Number cannot be
                                            found.</mat-error>
                
                                    </div>
                                    
                                    <div class="col-5 px-0 sg-part-btn">
                                        <button mat-raised-button type="button"
                                            [disabled]="isDisableGenQR"
                                            (click)="onSearchAndDownloadQRClick()" style="width: 95%;"
                                            class="mat-focus-indicator mat-primary mat-raised-button sg-QR-button mr-2 d-flex align-items-center">
                                            <mat-icon>download</mat-icon>
                                            <span>Download QR</span>
                                        </button>
                                    </div>
                                    
                
                                </div>
                                <div class="row mx-0 qr-link">
                                    <div class="mx-0 px-0 sg-primary" *ngIf="generateQRLink"
                                     (click)="onClickDownloadFiles('',generateQRLink)">
                                        <a target="_blank">{{generateQRLink}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mat-dialog-title border-bottom w-100 pb-2">Specifications</div>
            <div class="col-12 px-0 my-3 sg-sticker-specs">
                <p class="mb-2">QR Specs:</p>
                <ul *ngFor="let stickerSpecs of product_spec_Data.stickerSpecs">
                    <li [innerHTML]="stickerSpecs"></li>
                </ul>
            </div>
            <div class="col-12 px-0 mb-3 sg-fileSpec">
                <p class="mb-2">File Specs:</p>
                <ul *ngFor="let fileSpec of product_spec_Data.fileSpec">
                    <li [innerHTML]="fileSpec"></li>
                </ul>
            </div>
            <div class="mat-dialog-title border-bottom w-100 pb-2">CTA or Call to Action</div>
            <div class="col-12 px-0 mt-3">
                <p class="sg-qr-para-1">{{product_spec_Data.CTA}}</p>
                <p class="sg-qr-para-1">Approved CTAs: The following are approved CTAs</p>
                <div class="row mx-0 my-3 sg-qr-conatiner d-flex flex-wrap">
                    <div class="col-5 px-0 sg-general-qr mr-3">
                        <div class="row mx-0 flex-nowrap">
                            <div class="col-5 py-3 d-flex justify-content-center sg-qr-image">
                                <img src="assets/Images/yellow label (8 x 6 in) - Shop for partss- white.png" class="pb-0 sg-white-image" 
                        style="max-height: 170px;" />
                            </div>
                            <div class="col-7 sg-qr-right py-3 pl-3 pr-3 sg-qr-home-right">
                                <p class="text-capitalize title mb-0">Shop for Parts Online (White background)</p>
                                
                                <div class="content pt-2 mb-2">
                                    Shop for Parts Online (White background) Click "Download"
                                </div>
                                <div class="mt-4 py-2">
                                    <button mat-raised-button class="mat-raised-button mat-primary d-flex align-items-center"
                                        (click)="onClickGenerateDownloadLink('CTA_Shop_For_Parts_White')">
                                        <mat-icon>download</mat-icon>
                                        <span>Download</span>
                                    </button>
                                </div>
                                
                            </div>
                        </div>
                
                    </div>
                    <div class="col-6 px-0 sg-parts-qr">
                        <div class="row mx-0 flex-nowrap">
                            <div class="col-5 py-3 d-flex justify-content-center sg-qr-image">
                                <img src="assets/Images/yellow label (8 x 6 in) - shop for partss.png" class="pb-0 sg-parts-image" 
                        style="max-height: 170px;" />
                            </div>
                            <div class="col-7 sg-qr-right py-3 pl-3 pr-2 sg-qr-home-right">
                                <p class="text-capitalize title mb-0">Shop for Parts Online (Black background)</p>
                                
                                <div class="content pt-2 mb-2">
                                    Shop for Parts Online (Black background) Click "Download"
                                </div>
                                <div class="mt-4 py-2">
                                    <button mat-raised-button class="mat-raised-button mat-primary d-flex align-items-center"
                                        (click)="onClickGenerateDownloadLink('CTA_Shop_For_Parts_Black')">
                                        <mat-icon>download</mat-icon>
                                        <span>Download</span>
                                    </button>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mat-dialog-title border-bottom w-100 pb-2">Solar ® Logo/Wordmark</div>
            <div class="col-12 px-0 mt-3">
                <p class="sg-qr-para-1">{{product_spec_Data.SOLAR_LOGO}}</p>
                
                <div class="row mx-0 my-3 sg-qr-conatiner d-flex flex-wrap">
                    <div class="col-5 px-0 sg-general-qr mr-3">
                        <div class="row mx-0 flex-nowrap">
                            <div class="col-5 py-3 d-flex justify-content-center sg-qr-image">
                                <img src="assets/Images/SolarLogo.svg" class="pb-0" 
                        style="max-height: 170px;" />
                            </div>
                            <div class="col-7 sg-qr-right py-3 pl-3 pr-3 sg-qr-home-right">
                                <p class="text-capitalize title mb-0">Solar ® Logo/Wordmark</p>
                                  <div class="content pt-2 mb-2">
                                    To download, click "Download" to save the Solar wordmark/Trademark.
                                </div>
                                <div class="mt-2 pb-2 pt-4">
                                    <button mat-raised-button class="mat-raised-button mat-primary d-flex align-items-center"
                                        (click)="onClickGenerateDownloadLink('Solor_Wordmark_Logo')">
                                        <mat-icon>download</mat-icon>
                                        <span>Download</span>
                                    </button>
                                </div>
                               
                            </div>
                        </div>
                
                    </div>
                    
                </div>
            </div>
        </div>
        
    </div>
</section>

<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
</div>